export const API_GET_ALL_PROVIDER = 'API_GET_ALL_PROVIDER'
export const API_GET_ALL_PROVIDER_SUCCESS = 'API_GET_ALL_PROVIDER_SUCCESS'
export const API_GET_ALL_PROVIDER_FAIL = 'API_GET_ALL_PROVIDER_FAIL'